import { IndexSeries } from '../';
import { RemoteMixin } from '../../RemoteMixin';

export class RemoteIndexSeries extends RemoteMixin(IndexSeries) { }